export default {
  name: "webMeetings",
  component: () =>
    import(
      /* webpackChunkName: "webMeetingsLayout" */ "@/modules/videoConferencia/layouts/WebMeetingsLayout.vue"
    ),
  redirect: "/webMeetings/meetings",
  children: [
    {
      path: "meetings",
      name: "webMeetings-meetings",
      component: () =>
        import(
          /* webpackChunkName: "meetings" */ "@/modules/videoConferencia/pages/WebMeetings.vue"
        ),
    },
  ],
};
